import { signal } from "@preact/signals-react"

// Drawer state — { mode: 'create'|'edit', skuGroupID?, name?, skuIDs? }
export const skuGroupDrawerFilters = signal({})

// Users modal state — { skuGroupID, name } when set opens the users modal
export const skuGroupUsersModalFilters = signal({})

// Detail modal state — row data when set opens the detail modal
export const skuGroupDetailModalFilters = signal({})

// User groups modal state — { userID, userName, customerID, groupIDs }
export const skuGroupUserModalFilters = signal({})

// Trigger to reload main table
export const reloadSkuGroupFilters = signal(0)

export const resetManagementSkuGroupCrudsFilters = () => {
    skuGroupDrawerFilters.value = {}
    skuGroupUsersModalFilters.value = {}
    skuGroupDetailModalFilters.value = {}
    skuGroupUserModalFilters.value = {}
    reloadSkuGroupFilters.value = 0
}
